import { Component, OnInit } from '@angular/core';
//import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
//import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
//import { Router } from '@angular/router';
//import { CommonDataService } from '../../common/services/common-data.service';
//import { ValidationService } from '../../common/services/validation.service';
//import { ConfigurationService } from '../../common/services/configuration.service';
//import { GraphqlService } from '../../common/services/graphql.service';
//import { LoginService } from "../../common/services/Login.service";
@Component({
  selector: 'app-Login',
  templateUrl: './Login.component.html'
})
export class LoginComponent implements OnInit {

  //@ViewChild('loginUsernameLabel') userNameElement: ElementRef;
  //@ViewChild('loginPasswordLabel') passwordElement: ElementRef;

  //hide = true;  // For password field
  //userName: string = ""; //for username
  //passWord: string = ""; //for username
  //minPw: number = 8;
  //WarningMessage: string;
  //basicAccInfo: string;
  //public aFormGroup: FormGroup;
  //apiError: boolean = false;
  //usernameError
  //passwordError;
  //usernameLabel;
  //passwordLabel
  //  LoginFailed: any;

  constructor(
    //private route: Router,
    //private _loginservice: LoginService,
    //private formBuilder: FormBuilder,
    //private _validationService: ValidationService,
    //private _commonDataService: CommonDataService,
    //private _configurationservice: ConfigurationService,
    //private graphQlService: GraphqlService


  ) { }

  //emailFormControl = new FormControl('');
  //passwordvalidation = new FormControl('');


  //public resolved(captchaResponse: string): void {
  //  console.log('Resolved captcha with response: ' + captchaResponse);
  //  document.getElementById("btnBasicView").removeAttribute("disabled");
  //  document.getElementById("btnBasicView").classList.remove("btn-secondary-disabled-basic");
  //  document.getElementById("btnBasicView").classList.add("btn-secondary-basic", "cursor-pointer");
  //};

  ngOnInit() {
    //  this.aFormGroup = this.formBuilder.group({
    //    recaptcha: ['', Validators.required]
    //  });
    //  if (localStorage.getItem("userObject") == undefined) {
    //    window.localStorage.setItem("userObject", "null");

    //    this._loginservice.SetSession("null").subscribe(data => {
    //      if (data != "") {
    //        // alert("session storage set successfully : " + data.user);
    //      }
    //    });
    //  }
    //  this.graphQlService.getLoginPageContent("1", "9").subscribe(data => {
    //   var response = data.result.content.data.linkList
    //    for (let i = 0; i < response.length; i++) {
    //      console.log(response[i])
    //      //this.footerLinkData.push(
    //      //  {
    //      //    displayText: this.footerAPIResponse[i].linkTitle,
    //      //    link: this.footerAPIResponse[i].linkText,
    //      //    isBold: false
    //      //  }
    //      //)
    //    }

    //  });
    //}
    //accessBasicView() {
    //  window.localStorage.setItem("userObject", "Basic");

    //  this._loginservice.SetSession("Basic").subscribe(data => {
    //    if (data != "") {

    //      this._loginservice.getSession().subscribe(res => {
    //        let sesStore = window.localStorage.getItem("userObject");
    //        if (res.user.roles == sesStore) {
    //          //this.route.navigate(["PublicationList"]);
    //          this.route.navigate([this._configurationservice.publicationid]);
    //        }
    //      });

    //    }
    //    //this._loginservice.gettest("test").subscribe(data => {
    //    //  // alert(data);
    //    //});

    //  });
  }
  //AccountFAQ() {

  //}
  //TermsandCondition() {
  //  this.route.navigate(["Terms"]);
  //}
  //checkEmail() {
  //  let emailValid = true
  //  if (!this._validationService.validateRequiredField(this.emailFormControl.value)) {
  //    this.emailFormControl.setErrors({ 'required': true });
  //    this.usernameError = this._validationService.getErrorMessage('required', "Email address", null);
  //    this.emailFormControl.markAsTouched();
  //    emailValid = false
  //  } else if (!this._validationService.validateEmail(this.emailFormControl.value)) {
  //    this.emailFormControl.setErrors({ 'hasInvalidEmail': true });
  //    this.usernameError = this._validationService.getErrorMessage('valid', "Email address", null);
  //    this.emailFormControl.markAsTouched();
  //    emailValid = false
  //  }

  //  if (emailValid) {
  //    this.emailFormControl.setErrors(null);
  //  }

  //  if (this.emailFormControl.errors) {
  //    console.log(Object.keys(this.emailFormControl.errors))
  //  } else {
  //    console.log(this.emailFormControl.errors)
  //  }
  //  return emailValid;
  //}

  //checkPassword() {
  //  let passwordValid = true;
  //  if (!this._validationService.validateRequiredField(this.passwordvalidation.value)) {
  //    this.passwordvalidation.setErrors({ 'isEmpty': true });
  //    this.passwordError = this._validationService.getErrorMessage('required', this.passwordLabel, null);
  //    this.passwordvalidation.markAsTouched();
  //    passwordValid = false
  //  }
  //  //else if (!this._validationService.validateMinimunStringLength(this.passwordvalidation.value, this.minPw)) {
  //  //  this.passwordvalidation.setErrors({ 'minlength': true });
  //  //  this.passwordError = this._validationService.getErrorMessage('minLength', this.passwordLabel, this.minPw);
  //  //  this.passwordvalidation.markAsTouched();
  //  //  passwordValid = false
  //  //}

  //  if (passwordValid) {
  //    this.passwordvalidation.setErrors(null);
  //  }

  //  return passwordValid;
  //}

  //ngAfterViewInit() {
  //  this.usernameLabel = this.userNameElement.nativeElement.children[0].children[0].children[0].firstElementChild.innerText;
  //  this.passwordLabel = this.passwordElement.nativeElement.children[0].children[0].children[0].firstElementChild.innerText;

  //}

  //loginProfessional() {
  //  this.apiError = false;
  //  let emailalid = this.checkEmail();
  //  let passwordValid = this.checkPassword();

  //  if (emailalid && passwordValid) {
  //    this._loginservice.getLoginValidation(this.emailFormControl.value, this.passwordvalidation.value).subscribe(data => {
  //      if (data.login == "valid") {
  //        window.localStorage.setItem("userObject", "Professional");
  //        this._loginservice.SetSession("Professional").subscribe(data => {

  //          this._loginservice.getSession().subscribe(res => {
  //            let sesStore = window.localStorage.getItem("userObject");
  //            if (res.user.roles == sesStore) {           
  //              this.route.navigate([this._configurationservice.publicationid]);
  //            }
  //            else {
  //              alert("storage is changed manually.");
  //            }
  //          });
  //        });
  //      }
  //      else if (data.login == "invalid") {
  //        this.apiError = true;
  //        this.LoginFailed = "Login failed: Invalid username or password. Please verify your credentials and try again. If that does not work, please contact";
  //      }
  //      else {
  //        let obj = {
  //          type: 'error',
  //          displayTime: 5000,
  //          position: 'bottom',
  //          message: data.errorMsg
  //        }
  //        this._commonDataService.notificationObject.next(obj);
  //      }
  //    });
  //  }

  //}
  //basicAccounthelp() {
  //  this.basicAccInfo = "The Financial Accounting Foundation has simplified access to the FASB Codification Basic View by removing the username/password requirement. User credentials can still be used to access existing user accounts in our webstore. Access to digital content remains subject to terms of use.";
  //  alert(this.basicAccInfo);
  //}

  //goToLink(url: string) {
  //  window.open(url, "_blank");
  //}
}
